import React from 'react';
import { cn } from '../../../utils/cn';

interface SearchRecentlySearchedPopupProps {
    recentlySearched: string[];
    clearHistory: () => void;
    onItemClick: (search: string) => void;
    variant?: 'default' | 'header';
    menuColor?: 'light' | 'dark';
}

export const SearchRecentlySearchedPopup: React.FC<
    SearchRecentlySearchedPopupProps
> = ({
    recentlySearched,
    onItemClick,
    clearHistory,
    variant = 'default',
    menuColor = 'dark',
}) => {
    return (
        <div
            className={cn(
                'absolute left-2 right-2 top-full z-popover mt-2 p-8 pl-13.5 pt-9',
                variant === 'header' && menuColor === 'light'
                    ? 'rounded-5 bg-black/20 shadow-lg backdrop-blur-xl'
                    : variant === 'header' && menuColor === 'dark'
                      ? 'rounded-5 bg-gray-100/40 shadow-lg backdrop-blur-xl'
                      : 'scrollbar-hide max-h-[calc(100vh-12rem)] overflow-y-auto rounded-xl border border-gray-300 bg-white shadow-lg',
            )}
            id="search-autocomplete"
            aria-haspopup="listbox"
        >
            <div>
                <span
                    className={cn(
                        'font-medium md:mb-0 md:text-base',
                        variant === 'header' && menuColor === 'light'
                            ? 'text-white'
                            : 'text-gray-800',
                    )}
                >
                    Recently Searched
                </span>
                <div className="my-4.5 space-y-2.5 md:my-2 md:space-y-0.5">
                    {recentlySearched.map((searchItem) => (
                        <div
                            key={searchItem}
                            onClick={() => onItemClick(searchItem)}
                            className={cn(
                                'group flex cursor-pointer items-center focus:outline-none',
                                variant === 'header' && menuColor === 'light'
                                    ? 'md:px-0 md:py-1 md:focus:bg-white/10'
                                    : variant === 'header' &&
                                        menuColor === 'dark'
                                      ? 'md:px-0 md:py-0.5 md:focus:bg-gray-200'
                                      : '',
                            )}
                            role="option"
                            tabIndex={0}
                            aria-selected={false}
                        >
                            <div
                                className={cn(
                                    'flex min-h-4.5 max-w-full items-center gap-1 whitespace-nowrap border-b border-transparent leading-[1.1] md:min-h-0 md:text-dropdown',
                                    variant === 'header' &&
                                        menuColor === 'light'
                                        ? 'text-white group-hover:border-white'
                                        : variant === 'header' &&
                                            menuColor === 'dark'
                                          ? 'text-gray-600 group-hover:border-gray-600'
                                          : 'text-[#9b9b9b] group-hover:border-gray-400 md:text-gray-400',
                                )}
                            >
                                <span>{searchItem}</span>
                            </div>
                        </div>
                    ))}
                    <div
                        onClick={clearHistory}
                        className={cn(
                            'flex cursor-pointer items-center focus:outline-none',
                            variant === 'header' && menuColor === 'light'
                                ? 'md:px-0 md:py-1'
                                : variant === 'header' && menuColor === 'dark'
                                  ? 'md:px-0 md:py-1'
                                  : '',
                        )}
                        role="option"
                        tabIndex={1}
                        aria-selected={false}
                    >
                        <div
                            className={cn(
                                'mt-4 flex min-h-4.5 max-w-full items-center gap-1 whitespace-nowrap leading-[1.1] md:min-h-0 md:text-dropdown',
                                variant === 'header' && menuColor === 'light'
                                    ? 'text-[#c0c0c0]'
                                    : variant === 'header' &&
                                        menuColor === 'dark'
                                      ? 'text-gray-600'
                                      : 'text-[#9b9b9b] md:text-gray-400',
                            )}
                        >
                            <span
                                className={cn(
                                    'font-medium md:text-dropdown',
                                    variant === 'header' &&
                                        menuColor === 'light'
                                        ? 'text-white'
                                        : 'text-gray-800',
                                )}
                            >
                                {`Clear History`}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
